import T from 'T'

import type { OptimizationJobContext } from 'slices/route/persistentOptimizationJobsSlice'
import type { AvoidanceApi } from 'types/api/route/routeOptimizationJob'

const AVOIDANCE_LABELS: Record<AvoidanceApi, string> = {
  tolls: T.TOLLS,
  highways: T.HIGHWAYS,
  uturns: T.U_TURNS,
  left_turns: T.LEFT_TURNS,
  right_turns: T.RIGHT_TURNS,
  sharp_turns: T.SHARP_TURNS,
  service_roads: T.SERVICE_ROADS,
}

// Past three the line wraps, which is the whole point of a one-line caption.
const VISIBLE_OPTIONS = 3

// Only this browser can answer: the submit takes these and neither the job read nor the payload returns them.
export const optimizationOptionsUsed = (context?: OptimizationJobContext | null): string | undefined => {
  if (!context?.optimizeFor && !context?.avoid?.length) return undefined

  const goal = context.optimizeFor === 'distance' ? T.DISTANCE : T.TIME
  const options = [
    `${T.OPTIMIZE_FOR} ${goal.toLowerCase()}`,
    ...(context.avoid ?? []).map(key => `${T.AVOID} ${AVOIDANCE_LABELS[key].toLowerCase()}`),
  ]

  const hidden = options.length - VISIBLE_OPTIONS
  const shown = options.slice(0, VISIBLE_OPTIONS).join(' · ')
  return hidden > 0 ? `${shown} · +${hidden} ${T.MORE}` : shown
}
